// extracted by mini-css-extract-plugin
export default {"sale-info":"styles__sale-info--KX4kz","sale-date":"styles__sale-date--AAbKS"};